import type { DateTimeRange } from './mutate-datetime-range';

/**
 * Accepts an array of DateTimeRanges and returns the sum of their durations in seconds.
 * @param timestamps
 * @returns
 */
export function sumDurationInDateRange(timestamps: Array<DateTimeRange>): number {
  const durations = timestamps.map(timestamp => {
    return timestamp.ended_at.diff(timestamp.started_at, ['seconds']).as('seconds');
  });

  return durations.reduce((total, current) => total + current, 0);
}
